// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-views-job-tsx": () => import("./../src/views/Job.tsx" /* webpackChunkName: "component---src-views-job-tsx" */),
  "component---src-views-page-tsx": () => import("./../src/views/Page.tsx" /* webpackChunkName: "component---src-views-page-tsx" */)
}

